import { render, staticRenderFns } from "./dataProgressCard.vue?vue&type=template&id=2a45b2ca&scoped=true&"
import script from "./dataProgressCard.vue?vue&type=script&lang=js&"
export * from "./dataProgressCard.vue?vue&type=script&lang=js&"
import style0 from "./dataProgressCard.vue?vue&type=style&index=0&id=2a45b2ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45b2ca",
  null
  
)

export default component.exports